import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { AttractionsFirestoreDocumentRequest } from '../../types';
import { responseHandler } from '../utils';

type MutationParams = {
    data: AttractionsFirestoreDocumentRequest;
};

// v3-createAttraction (codebase `admin`). Backend sam ustawia `languages` (ze słownika
// `languages`) i `baseLang: 'pl'` — to, co poleci z formularza, i tak zostanie nadpisane.
export const usePostAttractionFirestore = (
  options?: UseMutationOptions<void, AxiosError, MutationParams>,
): UseMutationResult<void, AxiosError, MutationParams> => useMutation<void, AxiosError, MutationParams>({
  mutationFn: ({ data }) => axiosInstance.post('/v3-createAttraction', data, {
    headers: { 'Content-Type': 'application/json' },
  }).then(responseHandler),
  ...options,
});
